// extracted by mini-css-extract-plugin
module.exports = {"box":"style_box__3NGMu","mob":"style_mob__2gzPe","email":"style_email__2-3Fg","input":"style_input__2XucF","label":"style_label__2xpYh"};